export enum NotificationType {
    error,
    warning,
    info,
    success,
}

export enum ApplicationStatus {
    "Live" = "Live",
    "Withdrawn" = "Withdrawn",
    "Called In" = "Called In",
    "Referred to GLA" = "Referred to GLA",
    "Returned From GLA" = "Returned From GLA",
    "Referred to SOS" = "Referred to SOS",
    "Returned From SOS" = "Returned From SOS",
    "APPEAL ARTICLE 12 PINS" = "APPEAL ARTICLE 12 PINS",
    "Further Information Required" = "Further Information Required",
    "Further Information Received" = "Further Information Received",
    "Returned" = "Returned",
    "Appeal Determined" = "Appeal Determined",
    "Determined" = "Determined",
    "Appealed" = "Appealed",
    "Received" = "Received",
    "Invalid" = "Invalid",
}

export enum NoticeStatus {
    "SERVED" = "SERVED",
    "WITHDRAWN" = "WITHDRAWN",
    "AWAITING SERVICE" = "AWAITING SERVICE",
    "AWAITING LEGAL" = "AWAITING LEGAL",
    "AWAITING AUTHORISATION" = "AWAITING AUTHORISATION",
    "RESOLVED" = "RESOLVED",
    "APPEALED" = "APPEALED",
}

export enum E_AppealLevel {
    "Planning Inspectorate" = "Planning Inspectorate",
    "High Court" = "High Court",
    "Court of Appeal" = "Court of Appeal",
    "Magistrates" = "Magistrates",
}

export enum AppealType {
    "Written" = "Written",
    "Hearing" = "Hearing",
    "Inquiry" = "Inquiry",
    "Householder" = "Householder",
}

export enum Title {
    "Miss" = "Miss",
    "Ms" = "Ms",
    "Mrs" = "Mrs",
    "Mr" = "Mr",
    "Dame" = "Dame",
    "Dr" = "Dr",
    "Mr & Mrs" = "Mr & Mrs",
    "Prof" = "Prof",
    "Sir" = "Sir",
}
